// @flow
import { createSelector } from 'reselect';
import { selectIsRiderManagerChatEnabled } from 'common/redux/selectors/clientSelector';
import { isGlobalPersonnelSelector } from 'common/redux/selectors/sessionSelector';

export const selectChatState = createSelector(
    state => state.chat,
    chat => chat
);

export const selectIsChatVisible = createSelector(
    selectIsRiderManagerChatEnabled,
    isGlobalPersonnelSelector,
    (isRiderManagerChatEnabled, isGlobalPersonnel) =>
        isRiderManagerChatEnabled && !isGlobalPersonnel
);
